<script>
  import lodash from 'lodash';
  import TableCellBase from './TableCellBase.vue';

  export default {
    name: 'TableCellActivePatientsSubtotal',
    extends: TableCellBase,
    data() {
      return {
        fields: [
          'total_active_patients_scit',
          'total_active_patients_scit',
          'total_active_patients_unknown',
        ],
      };
    },
    computed: {
      actualValueRaw() {
        return lodash.reduce(this.fields, (sum, field) => {
          return sum + parseInt(this.monthObj[field])
        }, 0);
      },
    },
  };
</script>
